export const TEXT = `Samples and products restricted for warehouse can only be delivered directly to your
address while regular products will be shipped to the fulfillment center. Please
remove such products or save them for later in your cart to proceed.`;